// extracted by mini-css-extract-plugin
export var attribution = "TestimonialLegacy-module--attribution--f6e35";
export var container = "TestimonialLegacy-module--container--08fcf";
export var copy = "TestimonialLegacy-module--copy--04fa5";
export var logo = "TestimonialLegacy-module--logo--2491f";